
















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import WorldMapComponent from '@/world/WorldMapComponent.vue';
import DateSelectorComponent from '@/components/DateSelectorComponent.vue';

@Component({
	components: {
		WorldMapComponent,
		DateSelectorComponent,
	},
})
export default class HomeComponent extends Vue {
	public get totalCount() {
		return this.$store.getters['world/getTotalCount'];
	}
}
